import { render, staticRenderFns } from "./LPBgImage.vue?vue&type=template&id=3b43b11b&scoped=true"
import script from "./LPBgImage.vue?vue&type=script&lang=ts"
export * from "./LPBgImage.vue?vue&type=script&lang=ts"
import style0 from "./LPBgImage.vue?vue&type=style&index=0&id=3b43b11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43b11b",
  null
  
)

export default component.exports